import React, { useState, useEffect } from 'react';
import { Chart, ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';
import { useNavigate } from 'react-router-dom';
import {
  FiLogOut,
  FiUser,
  FiFileText,
  FiPrinter,
  FiPlus,
  FiUsers,
  FiHome,
  FiSearch,
  FiDownload,
  FiEdit2,
  FiTrash2,
  FiEye,
  FiArrowLeft,
  FiLock,
  FiMenu,
  FiChevronLeft,
  FiDollarSign,
  FiCheckCircle,
  FiClock,
  FiXCircle,
} from 'react-icons/fi';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { pdf, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import Modal from 'react-modal';
import LogoTipo from '../../../assets/logo.png'; 
import { Image } from '@react-pdf/renderer';
import { Pie } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

Chart.register(ArcElement, BarElement, CategoryScale, LinearScale, Tooltip, Legend);
// Configuração do Modal
Modal.setAppElement('#root');

// No início do arquivo, adicione:
const initialUsers = [
  { id: 1, username: 'admin', password: 'Admin007', role: 'admin', name: 'Administrador' },
  { id: 2, username: 'funcionario', password: 'func123', role: 'employee', name: 'Funcionário' }
];

const initialApplications = [
  {
    id: 1,
    nomeCompleto: 'João da Silva',
    docIdentificacao: '123456789',
    curso: 'Preparatório para Engenharia',
    paymentStatus: 'paid',
  },
];

function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(`Erro ao carregar ${key}:`, error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      setStoredValue(value);
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Erro ao salvar ${key}:`, error);
    }
  };

  return [storedValue, setValue];
}

// Estilos para o PDF
const pdfStyles = StyleSheet.create({
  page: { 
    padding: 40, 
    fontFamily: 'Helvetica',
     fontSize: 12, lineHeight: 1.5 
    },
  header: { 
    marginBottom: 20, 
    alignItems: 'center' 
  },
  institutionName: { 
    fontSize: 14, 
    fontWeight: 'bold', 
    color: '#00761F', 
    textTransform: 'uppercase' 
  },
  documentTitle: { 
    fontSize: 16, 
    fontWeight: 'bold', 
    marginVertical: 10, 
    color: '#00761F', 
    textTransform: 'uppercase' 
  },
  headerDivider: { 
    width: '100%', 
    height: 2, 
    backgroundColor: '#00761F', 
    marginVertical: 10 
  },
  section: { 
    marginBottom: 15 
  },
  sectionTitle: { 
    fontSize: 12, 
    fontWeight: 'bold', 
    marginBottom: 8, 
    color: '#00761F', 
    backgroundColor: '#f0f0f0', 
    padding: 5, 
    textTransform: 'uppercase' 
  },
  dataRow: { 
    flexDirection: 'row', 
    marginBottom: 5, 
    paddingHorizontal: 5 
  },
  dataLabel: { 
    width: '40%', 
    fontWeight: 'bold' 
  },
  dataValue: { 
    width: '60%' 
  },
  courseName: { 
    color: '#00761F', 
    fontWeight: 'bold' 
  },
  paymentSection: { 
    marginTop: 20, 
    borderTop: '1px solid #00761F', 
    paddingTop: 15
  },
  paymentValue: { 
    fontSize: 14, 
    fontWeight: 'bold', 
    color: '#00761F', 
    textAlign: 'center', 
    marginVertical: 10 
  },
  signatureArea: { 
    marginTop: 40, 
    flexDirection: 'row', 
    justifyContent: 'space-between' 
  },
  signatureBox: { 
    width: '45%', 
    borderTop: '1px solid #000', 
    paddingTop: 5, 
    textAlign: 'center' 
  },
  footer: { 
    marginTop: 30, 
    fontSize: 10, 
    textAlign: 'center', 
    color: '#666666' 
  },
  footerDivider: { 
    width: '100%', 
    height: 1, 
    backgroundColor: '#00761F', 
    marginBottom: 10 
  },
  footerText: { 
    marginBottom: 3 
  },
  footerNote: { 
    marginTop: 10, 
    fontStyle: 'italic' },
    logoContainer: {
  alignItems: 'center',
  marginBottom: 10
},
logo: {
  width: 100,
  height: 'auto',
  objectFit: 'contain'
}
  
});

const ReciboPagamentoPDF = ({ dados, user }) => (
  <Document>
    <Page size="A4" style={pdfStyles.page}>
      <View style={pdfStyles.header}>
        <View style={pdfStyles.logoContainer}>
        <Image 
          style={pdfStyles.logo} 
          src={LogoTipo} 
        />
      </View>
        <Text style={pdfStyles.institutionName}>INSTITUTO SUPERIOR POLITÉCNICO ATLÂNTIDA</Text>
        <Text style={pdfStyles.documentTitle}>RECIBO DE INSCRIÇÃO</Text>
        <View style={pdfStyles.headerDivider} />
      </View>

      <View style={pdfStyles.section}>
        <Text style={pdfStyles.sectionTitle}>IDENTIFICAÇÃO DO FORMANDO</Text>
        <View style={pdfStyles.dataRow}>
          <Text style={pdfStyles.dataLabel}>Nº da Ficha:</Text>
          <Text style={pdfStyles.dataValue}>{dados.numeroRecibo || Math.random().toString(36).substring(2, 10).toUpperCase()}</Text>
        </View>
        <View style={pdfStyles.dataRow}>
          <Text style={pdfStyles.dataLabel}>Data da Inscrição:</Text>
          <Text style={pdfStyles.dataValue}>{dados.dataPagamento || new Date().toLocaleDateString('pt-PT')}</Text>
        </View>
        <View style={pdfStyles.dataRow}>
          <Text style={pdfStyles.dataLabel}>Nome Completo:</Text>
          <Text style={pdfStyles.dataValue}>{dados.nomeCompleto}</Text>
        </View>
        <View style={pdfStyles.dataRow}>
          <Text style={pdfStyles.dataLabel}>Documento de Identificação:</Text>
          <Text style={pdfStyles.dataValue}>{dados.docIdentificacao} ({dados.tipoDocumento})</Text>
        </View>
        <View style={pdfStyles.dataRow}>
          <Text style={pdfStyles.dataLabel}>Data de Nascimento:</Text>
          <Text style={pdfStyles.dataValue}>{dados.dataNascimento}</Text>
        </View>
        <View style={pdfStyles.dataRow}>
          <Text style={pdfStyles.dataLabel}>Gênero:</Text>
          <Text style={pdfStyles.dataValue}>{dados.genero}</Text>
        </View>
        <View style={pdfStyles.dataRow}>
          <Text style={pdfStyles.dataLabel}>Email:</Text>
          <Text style={pdfStyles.dataValue}>{dados.email}</Text>
        </View>
        <View style={pdfStyles.dataRow}>
          <Text style={pdfStyles.dataLabel}>Telefone:</Text>
          <Text style={pdfStyles.dataValue}>{dados.telefone}</Text>
        </View>
        <View style={pdfStyles.dataRow}>
          <Text style={pdfStyles.dataLabel}>Curso:</Text>
          <Text style={pdfStyles.dataValue}>{dados.curso}</Text>
        </View>
        <View style={pdfStyles.dataRow}>
          <Text style={pdfStyles.dataLabel}>Turno:</Text>
          <Text style={pdfStyles.dataValue}>{dados.turno}</Text>
        </View>
      </View>
      <View style={pdfStyles.dataRow}>
      <Text style={pdfStyles.dataLabel}>Estado de Pagamento:</Text>
      <Text style={pdfStyles.dataValue}>
        {dados.paymentStatus === 'pending' ? 'Pendente' :
        dados.paymentStatus === 'paid' ? 'Pago' : 'Não Pago'}
      </Text>
    </View>
      <View style={pdfStyles.footer}>
        <View style={pdfStyles.footerDivider} />
        <Text style={pdfStyles.footerText}>Instituto Superior Politécnico Atlântida</Text>
        <Text style={pdfStyles.footerText}>Benfica, Estrada Lar do Patriota, Junto a Rua 14, Luanda, Angola</Text>
        <Text style={pdfStyles.footerText}>Tel: +244 929 282 704 | Email: secretariageral@ispatlantida.co.ao</Text>
        <Text style={pdfStyles.footerNote}>
          {dados.notasRecibo || 'Esta ficha garante a sua inscrição de candidatura para o curso preparatório.'}
        </Text>
      </View>
    </Page>
  </Document>
);

const AdminPanel = () => {
  const [user, setUser] = useState(null);
  const [applications, setApplications] = useState([]);
  const [users, setUsers] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [searchTerm, setSearchTerm] = useState('');
  const [stats, setStats] = useState({
    total: 0,
    engenharia: 0,
    saude: 0,
    direito: 0,
    economia: 0,
    paid: 0,
    notPaid: 0
  });
  const [editingApplication, setEditingApplication] = useState(null);
  const [loadingError, setLoadingError] = useState(null);
  
  const [isViewMode, setIsViewMode] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [, setIsEditingPassword] = useState(false);
  const [, setShowChangePassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [notification, setNotification] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [hasSeenWelcome, setHasSeenWelcome] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [currentPrintApplication, setCurrentPrintApplication] = useState(null);

  const clearFields = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

const [paymentModal, setPaymentModal] = useState({ isOpen: false, application: null });


const Loader = () => (
  <div style={{ textAlign: 'center', padding: '20px' }}>
    <motion.div
      animate={{ rotate: 360 }}
      transition={{ repeat: Infinity, duration: 1 }}
      style={{
        width: '40px',
        height: '40px',
        border: '4px solid #00761F',
        borderTopColor: 'transparent',
        borderRadius: '50%',
        margin: '0 auto',
      }}
    />
    <p>Carregando...</p>
  </div>
);
const CourseDistributionChart = ({ stats }) => {
  const data = {
    labels: ['Engenharia', 'Saúde', 'Direito', 'Economia'],
    datasets: [
      {
        data: [stats.engenharia, stats.saude, stats.direito, stats.economia],
        backgroundColor: ['#00761F', '#1a8cff', '#ff6f61', '#ffc107'],
        hoverBackgroundColor: ['#005c14', '#1478e6', '#ff4d4d', '#e6b800'],
      },
    ],
  };

  return (
    <Pie 
      data={data} 
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              color: '#333',
              font: {
                size: 12,
              },
            },
          },
        },
      }}
    />
  );
};


const PaymentStatusChart = ({ stats }) => {
  const data = {
    labels: ['Pagos', 'Pendentes', 'Não Pagos'],
    datasets: [
      {
        label: 'Status de Pagamento',
        data: [stats.paid, stats.pending, stats.notPaid],
        backgroundColor: ['#00761F', '#ffc107', '#dc3545'],
        borderColor: ['#005c14', '#e6b800', '#b02a37'],
        borderWidth: 1,
      },
    ],
  };

  return (
    <Bar 
      data={data} 
      options={{
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              color: '#333',
            },
          },
          x: {
            ticks: {
              color: '#333',
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
      }}
    />
  );
};

const StatCard = ({ value, label, icon }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        background: 'white',
        borderRadius: '10px',
        padding: '20px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
        textAlign: 'center',
        borderLeft: '4px solid #00761F',
      }}
    >
      <div style={{ fontSize: '32px', fontWeight: '700', color: '#00761F' }}>
        {icon} {value}
      </div>
      <div style={{ fontSize: '14px', color: '#666' }}>{label}</div>
    </motion.div>
  );
};

const openPaymentModal = (application) => {
  setPaymentModal({ isOpen: true, application });
};

const closePaymentModal = () => {
  setPaymentModal({ isOpen: false, application: null });
};

const handleUpdatePaymentStatus = () => {
  const updatedApplications = applications.map(app => 
    app.id === paymentModal.application.id ? { ...app, paymentStatus: paymentModal.application.paymentStatus } : app
  );
  setApplications(updatedApplications);
  localStorage.setItem('applications', JSON.stringify(updatedApplications));
  updateStats(updatedApplications);
  closePaymentModal();
  showNotification('Estado de pagamento atualizado com sucesso!');
};

<Modal
  isOpen={paymentModal.isOpen}
  onRequestClose={closePaymentModal}
  style={customModalStyles}
  contentLabel="Atualizar Estado de Pagamento"
>
  <ModalContent>
    <ModalTitle>Atualizar Estado de Pagamento</ModalTitle>
    <ModalText>Aluno: {paymentModal.application?.nomeCompleto}</ModalText>
    <FormGroup>
      <Label>Estado de Pagamento</Label>
      <Select
        value={paymentModal.application?.paymentStatus || 'pending'}
        onChange={(e) => 
          setPaymentModal({
            ...paymentModal,
            application: { ...paymentModal.application, paymentStatus: e.target.value }
          })
        }
      >
        <option value="pending">Pendente</option>
        <option value="paid">Pago</option>
        <option value="not_paid">Não Pago</option>
      </Select>
    </FormGroup>
    <ButtonGroup>
      <CancelButton onClick={closePaymentModal}>Cancelar</CancelButton>
      <SaveButton onClick={handleUpdatePaymentStatus}>Salvar</SaveButton>
    </ButtonGroup>
  </ModalContent>
</Modal>

  const navigate = useNavigate();

  useEffect(() => {
  const welcomeStatus = localStorage.getItem('hasSeenWelcome');
  if (!welcomeStatus && user) {
    setShowWelcomeModal(true);
    localStorage.setItem(hasSeenWelcome, 'true');
    setHasSeenWelcome(true); // Aqui estamos usando
  }
}, [hasSeenWelcome, user]);
  // Atualizar hora a cada minuto
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  
useEffect(() => {
  const handleStorageChange = () => {
    const storedApplications = localStorage.getItem('applications');
        if (!storedApplications) {
        setLoadingError('Nenhuma candidatura encontrada.');
      } else {
        try {
          const apps = JSON.parse(storedApplications);
          setApplications(apps);
          updateStats(apps);
        } catch (e) {
          setLoadingError('Erro ao carregar candidaturas.');
        }
      }
      
  };
  if (loadingError) {
  return (
    <ErrorState>
      <p>{loadingError}</p>
      <button onClick={() => window.location.reload()}>Tentar novamente</button>
    </ErrorState>
  );
}

  window.addEventListener('storage', handleStorageChange);

  const storedUsers = localStorage.getItem('users');
  const storedApplications = localStorage.getItem('applications');
  const currentUser = localStorage.getItem('currentUser');

  if (currentUser) {
    try {
      setUser(JSON.parse(currentUser));
    } catch (e) {
      console.error('Erro ao parsear usuário:', e);
    }
  }

  if (!storedUsers) {
    localStorage.setItem('users', JSON.stringify(initialUsers));
    setUsers(initialUsers);
  } else {
    try {
      setUsers(JSON.parse(storedUsers));
    } catch (e) {
      console.error('Erro ao parsear usuários:', e);
      setUsers(initialUsers);
    }
  }

  if (!storedApplications) {
    localStorage.setItem('applications', JSON.stringify([]));
    setApplications([]);
  } else {
    try {
      const apps = JSON.parse(storedApplications);
      setApplications(apps);
      updateStats(apps);
    } catch (e) {
      console.error('Erro ao parsear candidaturas:', e);
      setApplications([]);
    }
  }

  return () => {
    window.removeEventListener('storage', handleStorageChange);
  };
}, []);

function validateApplication(app) {
  return app.nomeCompleto && app.docIdentificacao && app.curso;
}

  const updateStats = (apps) => {
  const paidCount = apps.filter(app => app.paymentStatus === 'paid').length;
  const pendingCount = apps.filter(app => app.paymentStatus === 'pending').length;
  const notPaidCount = apps.filter(app => app.paymentStatus === 'not_paid').length;
  setStats({
    total: apps.length,
    engenharia: apps.filter(a => a.curso?.includes('Engenharia')).length,
    saude: apps.filter(a => a.curso?.includes('Saúde')).length,
    direito: apps.filter(a => a.curso?.includes('Direito')).length,
    economia: apps.filter(a => a.curso?.includes('Economia')).length,
    paid: paidCount,
    pending: pendingCount,
    notPaid: notPaidCount
  });
};

  const handleLogin = (loggedInUser) => {
    setUser(loggedInUser);
    localStorage.setItem('currentUser', JSON.stringify(loggedInUser));
    localStorage.removeItem('hasSeenWelcome');
    setShowWelcomeModal(true);
  };

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    setUser(null);
    localStorage.removeItem('currentUser');
    navigate('/');
    setShowLogoutModal(false);
  };

  const generateReceipt = async (application, type = 'A4') => {

    if (type === 'A4') {
      const blob = await pdf(<ReciboPagamentoPDF dados={application} />).toBlob();
      const pdfUrl = URL.createObjectURL(blob);
      const printWindow = window.open(pdfUrl);
      printWindow.onload = () => {
        printWindow.print();
      };
    } else {
       const thermalContent = `
      
    INSTITUTO SUPERIOR POLITÉCNICO ATLÂNTIDA
    ----------------------------
    RECIBO DE PAGAMENTO
    Emitido por: ${user.name}
    ----------------------------
    Nome: ${application.nomeCompleto}
    Data de Nascimento: ${application.dataNascimento}
    Gênero: ${application.genero}
    Documento: ${application.docIdentificacao}
    ----------------------------
    Curso: ${application.curso}
    Turno: ${application.turno}
    ----------------------------
    Email: ${application.email}
    Telefone: ${application.telefone}
    ----------------------------
    Estado de Pagamento: ${
      application.paymentStatus === 'pending' ? 'Pendente' :
      application.paymentStatus === 'paid' ? 'Pago' : 'Não Pago'
    }
    ----------------------------
    Valor: ${application.valorPago || '5.000 KZ'}
    Data: ${new Date().toLocaleDateString('pt-PT')}
    ----------------------------
    Assinatura do funcionário: ${user.name}
    Assinatura do Formando: ${application.nomeCompleto}
  `;

  const printWindow = window.open('', '_blank');
  printWindow.document.write(`
    <html>
      <head>
        <title>Recibo de Pagamento</title>
        <style>
          body { font-family: Arial, sans-serif; font-size: 12px; line-height: 1.5; }
          img { display: block; margin-bottom: 5px; }
          h3 { margin: 5px 0; font-size: 14px; font-weight: bold; }
        </style>
      </head>
      <body>
        <pre>${thermalContent}</pre>
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
    }
  };

  const PrintModal = ({ isOpen, onClose, onPrintA4, onPrintThermal }) => (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customModalStyles}
      contentLabel="Opções de Impressão"
    >
      <ModalContent>
        <ModalTitle>Selecione o Tipo de Impressão</ModalTitle>
        <ModalButtonsColumn>
          <PrintOptionButton onClick={onPrintA4}>
            <FiPrinter size={20} />
            <span>Ficha de Inscrição</span>
          </PrintOptionButton>
          <PrintOptionButton onClick={onPrintThermal}>
            <FiPrinter size={20} />
            <span>Recibo de pagamento</span>
          </PrintOptionButton>
          <ModalButtonCancel onClick={onClose}>
            Cancelar
          </ModalButtonCancel>
        </ModalButtonsColumn>
      </ModalContent>
    </Modal>
  );

  const exportToCSV = () => {
    if (applications.length === 0) return;
    
    const headers = Object.keys(applications[0]).join(';');
    const data = applications.map(app => 
      Object.values(app).map(value => 
        typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value
      ).join(';')
    ).join('\n');
    
    const csv = `${headers}\n${data}`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `candidaturas_${new Date().toISOString().split('T')[0]}.csv`);
  };

  const handleEditUser = (userToEdit) => {
    setEditingUser({ ...userToEdit });
    setIsEditingPassword(false);
  };

  const handleSaveUser = (e) => {
    e.preventDefault();
    
    let updatedUsers;
    if (editingUser.id) {
      updatedUsers = users.map(u => 
        u.id === editingUser.id ? editingUser : u
      );
    } else {
      updatedUsers = [
        ...users,
        {
          ...editingUser,
          id: Math.max(...users.map(u => u.id), 0) + 1
        }
      ];
    }
    
    setUsers(updatedUsers);
    localStorage.setItem('users', JSON.stringify(updatedUsers));
    setEditingUser(null);
    showNotification(editingUser.id ? 'Usuário atualizado com sucesso!' : 'Usuário adicionado com sucesso!');
  };

  const handleDeleteUser = (id) => {
    if (id === user?.id) {
      showNotification('Você não pode excluir seu próprio usuário!', 'error');
      return;
    }
    
    if (window.confirm('Tem certeza que deseja excluir este usuário?')) {
      const updatedUsers = users.filter(u => u.id !== id);
      setUsers(updatedUsers);
      localStorage.setItem('users', JSON.stringify(updatedUsers));
      showNotification('Usuário excluído com sucesso!');
    }
  };

  const handleChangePassword = (e) => {
    e.preventDefault();

    console.log('Senha alterada:', { currentPassword, newPassword, confirmPassword });
    if (currentPassword !== user.password) {
      showNotification('Senha atual incorreta!', 'error');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      showNotification('As senhas não coincidem!', 'error');
      return;
    }
    
    const updatedUsers = users.map(u => 
      u.id === user.id ? { ...u, password: newPassword } : u
    );
    
    setUsers(updatedUsers);
    setUser({ ...user, password: newPassword });
    localStorage.setItem('users', JSON.stringify(updatedUsers));
    localStorage.setItem('currentUser', JSON.stringify({ ...user, password: newPassword }));
    
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setShowChangePassword(false);
    
    showNotification('Senha alterada com sucesso!');
  };

  const handleEdit = (application) => {
    setEditingApplication(application);
    setIsViewMode(false);
  };

  const handleView = (application) => {
    setEditingApplication(application);
    setIsViewMode(true);
  };

const handleSaveEdit = (e) => {
  e.preventDefault();
  const updatedApplications = applications.map(app => 
    app.id === editingApplication.id ? editingApplication : app
  );
  setApplications(updatedApplications);
  localStorage.setItem('applications', JSON.stringify(updatedApplications));
  setEditingApplication(null);
  showNotification('Candidatura atualizada com sucesso!');
  updateStats(updatedApplications); // Atualiza as estatísticas após salvar
};

  const handleDelete = (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta candidatura?')) {
      const updatedApplications = applications.filter(app => app.id !== id);
      setApplications(updatedApplications);
      localStorage.setItem('applications', JSON.stringify(updatedApplications));
      updateStats(updatedApplications);
      showNotification('Candidatura excluída com sucesso!');
    }
  };

  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const filteredApplications = applications.filter(app => 
    app.nomeCompleto?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    app.docIdentificacao?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const formatDate = (date) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('pt-PT', options);
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
  };

 if (!user) {
  return <Login onLogin={handleLogin} />;
}

if (!applications.length) {
  return (
    <EmptyState>
      <p>Nenhuma candidatura encontrada.</p>
      {user.role === 'admin' && (
        <button onClick={() => setActiveTab('applications')}>Adicionar nova candidatura</button>
      )}
    </EmptyState>
  );
}
  return (
    <AdminContainer>
      {notification && (
        <Notification type={notification.type}>
          {notification.message}
        </Notification>
      )}
      
      {/* Modal de Confirmação de Logout */}
      <Modal
        isOpen={showLogoutModal}
        onRequestClose={() => setShowLogoutModal(false)}
        style={customModalStyles}
        contentLabel="Confirmar Logout"
      >
        <ModalContent>
          <ModalTitle>Confirmar Saída</ModalTitle>
          <ModalText>Tem certeza que deseja sair do sistema?</ModalText>
          <ModalButtons>
            <ModalButtonCancel onClick={() => setShowLogoutModal(false)}>
              Cancelar
            </ModalButtonCancel>
            <ModalButtonConfirm onClick={confirmLogout}>
              Sair
            </ModalButtonConfirm>
          </ModalButtons>
        </ModalContent>
      </Modal>
      
      {/* Modal de Boas Vindas */}
      <Modal
        isOpen={showWelcomeModal}
        onRequestClose={() => {
          setShowWelcomeModal(false);
          localStorage.setItem('hasSeenWelcome', 'true');
        }}
        style={customModalStyles}
        contentLabel="Bem-vindo"
      >
        <WelcomeModalContent>
          <Logo src={LogoTipo} alt="Logo Instituto Superior Politécnico Atlântida" />
          <WelcomeTitle>Bem-vindo, {user.name}!</WelcomeTitle>
          <WelcomeText>Você está logado como {user.role === 'admin' ? 'Administrador' : 'Funcionário'}</WelcomeText>
          <WelcomeButton onClick={() => {
            setShowWelcomeModal(false);
            localStorage.setItem('hasSeenWelcome', 'true');
          }}>
            Continuar
          </WelcomeButton>
        </WelcomeModalContent>
      </Modal>
      
      {/* Modal de Impressão */}
      <PrintModal
        isOpen={showPrintModal}
        onClose={() => setShowPrintModal(false)}
        onPrintA4={() => {
          generateReceipt(currentPrintApplication, 'A4');
          setShowPrintModal(false);
        }}
        onPrintThermal={() => {
          generateReceipt(currentPrintApplication, 'thermal');
          setShowPrintModal(false);
        }}
      />
      
      <Sidebar collapsed={sidebarCollapsed}>
        <SidebarHeader>
          {!sidebarCollapsed && (
            <LogoSmall src={LogoTipo} alt="Logo" width={50} height={50} />
          )}
          <ToggleSidebarButton onClick={() => setSidebarCollapsed(!sidebarCollapsed)}>
            {sidebarCollapsed ? <FiMenu size={20} /> : <FiChevronLeft size={20} />}
          </ToggleSidebarButton>
        </SidebarHeader>
        
        <UserInfo collapsed={sidebarCollapsed}>
          <UserAvatar>
            <FiUser size={20} />
          </UserAvatar>
          {!sidebarCollapsed && (
            <div>
              <UserName>{user.name}</UserName>
              <UserRole>{user.role === 'admin' ? 'Administrador' : 'Funcionário'}</UserRole>
            </div>
          )}
        </UserInfo>
        
        <Nav>
          <NavItem 
            active={activeTab === 'dashboard'} 
            onClick={() => setActiveTab('dashboard')}
            collapsed={sidebarCollapsed}
          >
            <FiHome size={18} />
            {!sidebarCollapsed && <span>Dashboard</span>}
          </NavItem>
          
          <NavItem 
            active={activeTab === 'applications'} 
            onClick={() => setActiveTab('applications')}
            collapsed={sidebarCollapsed}
          >
            <FiFileText size={18} />
            {!sidebarCollapsed && (
              <>
                <span>Candidaturas</span>
                <Badge>{applications.length}</Badge>
              </>
            )}
          </NavItem>
          
          {user.role === 'admin' && (
            <>
              <NavItem 
                active={activeTab === 'users'} 
                onClick={() => setActiveTab('users')}
                collapsed={sidebarCollapsed}
              >
                <FiUsers size={18} />
                {!sidebarCollapsed && <span>Usuários</span>}
              </NavItem>
              
              <NavItem 
                active={activeTab === 'change-password'} 
                onClick={() => {
                  setActiveTab('change-password');
                  setShowChangePassword(true);
                }}
                collapsed={sidebarCollapsed}
              >
                <FiLock size={18} />
                {!sidebarCollapsed && <span>Alterar Senha</span>}
              </NavItem>
            </>
          )}
        </Nav>
        
        <LogoutButton onClick={handleLogout} collapsed={sidebarCollapsed}>
          <FiLogOut size={18} />
          {!sidebarCollapsed && <span>Sair</span>}
        </LogoutButton>
      </Sidebar>
      
      <MainContent>
        <HeaderBar>
          <DateTimeInfo>
            <DayInfo>{formatDate(currentTime)}</DayInfo>
            <TimeInfo>{formatTime(currentTime)}</TimeInfo>
          </DateTimeInfo>
        </HeaderBar>
        
        {activeTab === 'dashboard' && (
         <DashboardContainer>
          <WelcomeMessage>Bem-vindo, {user.name}!</WelcomeMessage>

          {/* Gráfico de Distribuição de Cursos */}
          <SectionTitle>Distribuição de Candidaturas por Curso</SectionTitle>
          <GraphContainer>
            <CourseDistributionChart stats={stats} />
          </GraphContainer>

          {/* Gráfico de Status de Pagamento */}
          <SectionTitle>Status de Pagamento</SectionTitle>
          <GraphContainer>
            <PaymentStatusChart stats={stats} />
          </GraphContainer>

          {/* Cartões de Estatísticas */}
          <StatsGrid>
            <StatCard value={stats.total} label="Candidaturas Totais" icon={<FiFileText size={24} />} />
            <StatCard value={stats.paid} label="Pagos" icon={<FiCheckCircle size={24} />} />
            <StatCard value={stats.pending} label="Pendentes" icon={<FiClock size={24} />} />
            <StatCard value={stats.notPaid} label="Não Pagos" icon={<FiXCircle size={24} />} />
          </StatsGrid>

          {/* Últimas Candidaturas */}
          <RecentApplications>
            <SectionTitle>Últimas Candidaturas</SectionTitle>
            {applications.slice(0, 5).map(application => (
              <ApplicationItem key={application.id}>
                <ApplicationName>{application.nomeCompleto}</ApplicationName>
                <ApplicationDetails>
                  <span>{application.curso}</span>
                  <span>{new Date(application.dataInscricao).toLocaleDateString('pt-PT')}</span>
                </ApplicationDetails>
              </ApplicationItem>
            ))}
            {applications.length === 0 && (
              <NoResults>Nenhuma candidatura recente</NoResults>
            )}
          </RecentApplications>
        </DashboardContainer>
        )}
        
        {activeTab === 'applications' && (
          <ApplicationsContainer>
            {editingApplication ? (
              <EditFormContainer>
                <FormHeader>
                  <BackButton onClick={() => setEditingApplication(null)}>
                    <FiArrowLeft size={20} />
                  </BackButton>
                  <FormTitle>
                    {isViewMode ? 'Visualizar Candidatura' : 'Editar Candidatura'}
                  </FormTitle>
                </FormHeader>
                
                <Form onSubmit={handleSaveEdit}>
                  <FormRow>
                    <FormGroup>
                      <Label>Nome Completo</Label>
                      <Input 
                        type="text" 
                        value={editingApplication.nomeCompleto || ''} 
                        onChange={(e) => setEditingApplication({...editingApplication, nomeCompleto: e.target.value})}
                        disabled={isViewMode}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Data de Nascimento</Label>
                      <Input 
                        type="date" 
                        value={editingApplication.dataNascimento || ''} 
                        onChange={(e) => setEditingApplication({...editingApplication, dataNascimento: e.target.value})}
                        disabled={isViewMode}
                      />
                    </FormGroup>
                  </FormRow>

                  <FormRow>
                    <FormGroup>
                      <Label>Gênero</Label>
                      <Select
                        value={editingApplication.genero || ''}
                        onChange={(e) => setEditingApplication({...editingApplication, genero: e.target.value})}
                        disabled={isViewMode}
                      >
                        <option value="">Selecione</option>
                        <option value="Masculino">Masculino</option>
                        <option value="Feminino">Feminino</option>
                        <option value="Outro">Outro</option>
                      </Select>
                    </FormGroup>
                    <FormGroup>
                      <Label>Tipo de Documento</Label>
                      <Select
                        value={editingApplication.tipoDocumento || ''}
                        onChange={(e) => setEditingApplication({...editingApplication, tipoDocumento: e.target.value})}
                        disabled={isViewMode}
                      >
                        <option value="">Selecione</option>
                        <option value="Bilhete de Identidade">Bilhete de Identidade</option>
                        <option value="Passaporte">Passaporte</option>
                        <option value="Carta de Condução">Carta de Condução</option>
                      </Select>
                    </FormGroup>
                  </FormRow>

                  <FormRow>
                    <FormGroup>
                      <Label>Documento de Identificação</Label>
                      <Input 
                        type="text" 
                        value={editingApplication.docIdentificacao || ''} 
                        onChange={(e) => setEditingApplication({...editingApplication, docIdentificacao: e.target.value})}
                        disabled={isViewMode}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Curso</Label>
                      <Select
                        value={editingApplication.curso || ''}
                        onChange={(e) => setEditingApplication({...editingApplication, curso: e.target.value})}
                        disabled={isViewMode}
                      >
                        <option value="">Selecione</option>
                        <option value="Preparatório para Engenharia">Preparatório para Engenharia</option>
                        <option value="Preparatório para Saúde">Preparatório para Saúde</option>
                        <option value="Preparatório para Direito">Preparatório para Direito</option>
                        <option value="Preparatório para Economia">Preparatório para Economia</option>
                      </Select>
                    </FormGroup>
                  </FormRow>

                  <FormRow>
                    <FormGroup>
                      <Label>Turno</Label>
                      <Select
                        value={editingApplication.turno || ''}
                        onChange={(e) => setEditingApplication({...editingApplication, turno: e.target.value})}
                        disabled={isViewMode}
                      >
                        <option value="">Selecione</option>
                        <option value="Manhã">Manhã</option>
                      </Select>
                    </FormGroup>
                    <FormGroup>
                      <Label>Valor Pago</Label>
                      <Input 
                        type="text" 
                        value={editingApplication.valorPago || ''} 
                        onChange={(e) => setEditingApplication({...editingApplication, valorPago: e.target.value})}
                        disabled={isViewMode}
                      />
                    </FormGroup>
                  </FormRow>

                  <FormRow>
                    <FormGroup>
                      <Label>Valor por Extenso</Label>
                      <Input 
                        type="text" 
                        value={editingApplication.valorExtenso || ''} 
                        onChange={(e) => setEditingApplication({...editingApplication, valorExtenso: e.target.value})}
                        disabled={isViewMode}
                      />
                    </FormGroup>
                    <FormRow>
                    <FormGroup>
                      <Label>Estado de Pagamento</Label>
                      <Select
                        value={editingApplication.paymentStatus || 'pending'}
                        onChange={(e) => setEditingApplication({ ...editingApplication, paymentStatus: e.target.value })}
                        disabled={isViewMode}
                      >
                        <option value="pending">Pendente</option>
                        <option value="paid">Pago</option>
                        <option value="not_paid">Não Pago</option>
                      </Select>
                    </FormGroup>
                  </FormRow>
                    <FormGroup>
                      <Label>Data de Inscrição</Label>
                      <Input 
                        type="date" 
                        value={editingApplication.dataInscricao || ''} 
                        onChange={(e) => setEditingApplication({...editingApplication, dataInscricao: e.target.value})}
                        disabled={isViewMode}
                      />
                    </FormGroup>
                  </FormRow>

                  <FormRow>
                    <FormGroup>
                      <Label>Email</Label>
                      <Input 
                        type="email" 
                        value={editingApplication.email || ''} 
                        onChange={(e) => setEditingApplication({...editingApplication, email: e.target.value})}
                        disabled={isViewMode}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Telefone</Label>
                      <Input 
                        type="tel" 
                        value={editingApplication.telefone || ''} 
                        onChange={(e) => setEditingApplication({...editingApplication, telefone: e.target.value})}
                        disabled={isViewMode}
                      />
                    </FormGroup>
                  </FormRow>

                  <ButtonGroup>
                    <CancelButton type="button" onClick={() => setEditingApplication(null)}>
                      Voltar
                    </CancelButton>
                    {!isViewMode && (
                      <SaveButton type="submit">
                        Salvar Alterações
                      </SaveButton>
                    )}
                  </ButtonGroup>
                </Form>
              </EditFormContainer>
            ) : (
              <>
                <ApplicationsHeader>
                  <Title>Candidaturas</Title>
                  <Actions>
                    <SearchWrapper>
                      <FiSearch size={18} />
                      <SearchInput
                        type="text"
                        placeholder="Pesquisar..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </SearchWrapper>
                    {user.role === 'admin' && (
                      <ExportButton onClick={exportToCSV}>
                        <FiDownload size={16} />
                        Exportar CSV
                      </ExportButton>
                    )}
                  </Actions>
                </ApplicationsHeader>
                
                <ApplicationsList>
                  {filteredApplications.length > 0 ? (
                    <Table>
                      <thead>
                        <tr>
                        <TableHeader>Nome</TableHeader>
                        <TableHeader>Documento</TableHeader>
                        <TableHeader>Curso</TableHeader>
                        <TableHeader>Data</TableHeader>
                        <TableHeader>Pagamento</TableHeader>
                        <TableHeader>Ações</TableHeader>
                      </tr>
                      </thead>
                      <tbody>
                        {filteredApplications.map(application => (
                          <TableRow key={application.id}>
                            <TableCell>{application.nomeCompleto}</TableCell>
                            <TableCell>{application.docIdentificacao} ({application.tipoDocumento})</TableCell>
                            <TableCell>{application.curso}</TableCell>
                            <TableCell>
                              {new Date(application.dataInscricao).toLocaleDateString('pt-PT')}
                            </TableCell>
                            <TableCell>
                            {application.paymentStatus === 'pending' ? 'Pendente' :
                            application.paymentStatus === 'paid' ? 'Pago' : 'Não Pago'}
                          </TableCell>
                       <TableCell>
                        <ActionButton onClick={() => handleEdit(application)}>
                          <FiEdit2 size={16} />
                        </ActionButton>
                        <ActionButton onClick={() => handleView(application)}>
                          <FiEye size={16} />
                        </ActionButton>
                        {user.role === 'admin' && (
                          <>
                            <ActionButton onClick={() => openPaymentModal(application)}>
                              <FiDollarSign size={16} />
                            </ActionButton>
                            <DeleteButton onClick={() => handleDelete(application.id)}>
                              <FiTrash2 size={16} />
                            </DeleteButton>
                          </>
                        )}
                        <ActionButton onClick={() => {
                          setCurrentPrintApplication(application);
                          setShowPrintModal(true);
                        }}>
                          <FiPrinter size={16} />
                        </ActionButton>
                      </TableCell>
                          </TableRow>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <NoResults>Nenhuma candidatura encontrada</NoResults>
                  )}
                </ApplicationsList>
              </>
            )}
          </ApplicationsContainer>
        )}
        
      {activeTab === 'users' && user.role === 'admin' && (
      <UsersContainer>
      <Header>
        <Title>Gerenciar Usuários</Title>
        <AddButton onClick={() => handleEditUser({
          username: '',
          password: '',
          name: '',
          role: 'employee'
        })}>
          <FiPlus size={18} />
          Adicionar Usuário
        </AddButton>
      </Header>
      {editingUser ? (
        <EditFormContainer>
          <FormHeader>
            <BackButton onClick={() => setEditingUser(null)}>
              <FiArrowLeft size={20} />
            </BackButton>
            <FormTitle>
              {editingUser.id ? 'Editar Usuário' : 'Adicionar Usuário'}
            </FormTitle>
          </FormHeader>
          <Form onSubmit={handleSaveUser}>
            <FormRow>
              <FormGroup>
                <Label>Nome Completo</Label>
                <Input 
                  type="text" 
                  value={editingUser.name} 
                  onChange={(e) => setEditingUser({...editingUser, name: e.target.value})} 
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Nome de Usuário</Label>
                <Input 
                  type="text" 
                  value={editingUser.username} 
                  onChange={(e) => setEditingUser({...editingUser, username: e.target.value})} 
                  required
                  disabled={!!editingUser.id}
                />
              </FormGroup>
            </FormRow>
            <FormRow>
              <FormGroup>
                <Label>Tipo de Usuário</Label>
                <Select
                  value={editingUser.role}
                  onChange={(e) => setEditingUser({...editingUser, role: e.target.value})}
                >
                  <option value="employee">Funcionário</option>
                  <option value="admin">Administrador</option>
                </Select>
              </FormGroup>
              <FormGroup>
                <Label>Senha</Label>
                <Input 
                  type="password" 
                  value={editingUser.password} 
                  onChange={(e) => setEditingUser({...editingUser, password: e.target.value})} 
                  required
                />
              </FormGroup>
            </FormRow>
            <ButtonGroup>
              <CancelButton type="button" onClick={() => setEditingUser(null)}>
                Cancelar
              </CancelButton>
              <SaveButton type="submit">
                Salvar
              </SaveButton>
            </ButtonGroup>
          </Form>
        </EditFormContainer>
      ) : (
        <UsersList>
          <Table>
            <thead>
              <tr>
                <TableHeader>Nome</TableHeader>
                <TableHeader>Usuário</TableHeader>
                <TableHeader>Tipo</TableHeader>
                <TableHeader>Ações</TableHeader>
              </tr>
            </thead>
            <tbody>
              {users.map(userItem => (
                <TableRow key={userItem.id}>
                  <TableCell>{userItem.name}</TableCell>
                  <TableCell>{userItem.username}</TableCell>
                  <TableCell>
                    <UserRoleBadge admin={userItem.role === 'admin'}>
                      {userItem.role === 'admin' ? 'Administrador' : 'Funcionário'}
                    </UserRoleBadge>
                  </TableCell>
                  <TableCell>
                    <ActionButton onClick={() => handleEditUser(userItem)}>
                      <FiEdit2 size={16} />
                    </ActionButton>
                    <DeleteButton 
                      onClick={() => handleDeleteUser(userItem.id)}
                      disabled={userItem.id === user.id}
                    >
                      <FiTrash2 size={16} />
                    </DeleteButton>
                  </TableCell>
                </TableRow>
              ))}
            </tbody>
          </Table>
        </UsersList>
      )}
      </UsersContainer>
      )}

        
        {activeTab === 'change-password' && (
      <ChangePasswordContainer>
      <FormTitle>Alterar Senha</FormTitle>
      <Form onSubmit={handleChangePassword}>
        {/* Campo Senha Atual */}
        <FormGroup>
          <Label style={{ marginTop: '8px' }}>Senha Atual</Label>
          <InputWrapper>
            <Input
              type={showCurrentPassword ? 'text' : 'password'}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
            <TogglePasswordVisibility
              onClick={() => setShowCurrentPassword(!showCurrentPassword)}
              showPassword={showCurrentPassword}
            />
          </InputWrapper>
        </FormGroup>

        {/* Campo Nova Senha */}
        <FormGroup>
          <Label style={{ marginTop: '8px' }}>Nova Senha</Label>
          <InputWrapper>
            <Input
              type={showNewPassword ? 'text' : 'password'}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <TogglePasswordVisibility
              onClick={() => setShowNewPassword(!showNewPassword)}
              showPassword={showNewPassword}
            />
          </InputWrapper>
        </FormGroup>

        {/* Campo Confirmar Nova Senha */}
        <FormGroup>
          <Label style={{ marginTop: '8px' }}>Confirmar Nova Senha</Label>
          <InputWrapper>
            <Input
              type={showConfirmPassword ? 'text' : 'password'}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <TogglePasswordVisibility
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              showPassword={showConfirmPassword}
            />
          </InputWrapper>
        </FormGroup>

        {/* Botões */}
        <ButtonGroup>
          <CancelButton type="button" onClick={() => setShowChangePassword(false)}>
            Cancelar
          </CancelButton>
          <ClearButton type="button" onClick={clearFields}>
            Limpar
          </ClearButton>
          <SaveButton type="submit">
            Alterar Senha
          </SaveButton>
        </ButtonGroup>
      </Form>
    </ChangePasswordContainer>


        )}
      </MainContent>
    </AdminContainer>
  );
};

const InputWrapper = ({ children }) => (
  <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
    {children}
  </div>
);

const TogglePasswordVisibility = ({ onClick, showPassword }) => (
  <span
    style={{
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      cursor: 'pointer',
      color: '#00761F',
    }}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
  </span>
);

const ClearButton = ({ onClick }) => (
  <button
    style={{
      padding: '10px 20px',
      backgroundColor: '#f44336',
      color: '#fff',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    }}
    onClick={onClick}
  >
    Limpar
  </button>
)

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    const storedUsers = JSON.parse(localStorage.getItem('users') || '[]');
    const user = storedUsers.find(u => 
      u.username === username && u.password === password
    );
    
    if (user) {
      onLogin(user);
    } else {
      setError('Credenciais inválidas. Por favor, tente novamente.');
    }
  };
  
  return (
<LoginContainer>
  <LoginForm onSubmit={handleSubmit}>
    <Logo src={LogoTipo} alt="Logo Instituto Superior Politécnico Atlântida"  />
    <LoginTitle>Sistema de Candidaturas</LoginTitle>
    <p style={{ color: '#555', fontSize: '14px', marginBottom: '25px' }}>
      Faça login para acessar o painel administrativo
    </p>
    {error && <ErrorMessage>{error}</ErrorMessage>}
    
    <FormGroup>
      <InputIcon><FiUser size={18} /></InputIcon>
      <IconWrapper>
        <Input 
          type="text" 
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          placeholder="Nome de usuário"
        />
      </IconWrapper>
    </FormGroup>
    <FormGroup>
      <IconWrapper>
        <InputIcon><FiLock size={18} /></InputIcon>
        <Input 
          type="password" 
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          placeholder="Senha"
        />
      </IconWrapper>
    </FormGroup>
    <LoginButton type="submit">Entrar</LoginButton>
  </LoginForm>
</LoginContainer>
  );
};

// Estilos usando styled-components
const AdminContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
`;

const IconWrapper = styled.div`
  position: relative;
`;

const InputIcon = styled.span`
  position: absolute;
  top: 50%;
  left: 330px;
  transform: translateY(-50%);
  color: #6c757d;
  z-index: 1;
`;

const Sidebar = styled.div`
  width: ${props => props.collapsed ? '80px' : '280px'};
  background: linear-gradient(180deg, #00761F 0%, #004d14 100%);
  color: white;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const SidebarHeader = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const LogoSmall = styled.img`
  width: 50px;
  max-width: 160px;
`;

const ToggleSidebarButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const UserInfo = styled.div`
  padding: ${props => props.collapsed ? '20px 10px' : '20px'};
  display: flex;
  align-items: center;
  gap: ${props => props.collapsed ? '0' : '15px'};
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const UserAvatar = styled.div`
  width: ${props => props.collapsed ? '40px' : '50px'};
  height: ${props => props.collapsed ? '40px' : '50px'};
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const UserName = styled.div`
  font-weight: 600;
  font-size: 16px;
`;

const UserRole = styled.div`
  font-size: 12px;
  opacity: 0.8;
`;

const Nav = styled.nav`
  flex: 1;
  padding: 20px 0;
  overflow-y: auto;
`;

const NavItem = styled.div`
  display: flex;
  align-items: center;
  padding: ${props => props.collapsed ? '15px 20px' : '15px 20px'};
  margin: 0 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: ${props => props.active ? 'rgba(255, 255, 255, 0.15)' : 'transparent'};
  color: ${props => props.active ? 'white' : 'rgba(255, 255, 255, 0.8)'};
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  span {
    margin-left: ${props => props.collapsed ? '0' : '15px'};
    display: ${props => props.collapsed ? 'none' : 'inline'};
    flex: 1;
  }
`;

const Badge = styled.span`
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 12px;
  margin-left: auto;
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  padding: ${props => props.collapsed ? '15px 20px' : '15px 20px'};
  margin: 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border: none;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
  
  span {
    margin-left: ${props => props.collapsed ? '0' : '15px'};
    display: ${props => props.collapsed ? 'none' : 'inline'};
  }
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const HeaderBar = styled.header`
  background-color: white;
  padding: 15px 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

const DateTimeInfo = styled.div`
  text-align: right;
`;

const DayInfo = styled.div`
  font-size: 14px;
  color: #555;
`;

const TimeInfo = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #00761F;
`;

const DashboardContainer = styled.div`
  flex: 1;
  padding: 30px;
  overflow-y: auto;
`;

const WelcomeMessage = styled.h1`
  font-size: 24px;
  color: #333;
  margin-bottom: 30px;
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const RecentApplications = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
`;

const ApplicationItem = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
  }
`;

const ApplicationName = styled.div`
  font-weight: 600;
  margin-bottom: 5px;
`;

const ApplicationDetails = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #666;
`;

const ApplicationsContainer = styled.div`
  flex: 1;
  padding: 30px;
  overflow-y: auto;
`;

const ApplicationsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

const Title = styled.h1`
  font-size: 24px;
  color: #333;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  padding: 8px 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  margin-left: 10px;
  font-size: 14px;
  width: 200px;
`;

const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #00761F;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #00661a;
  }
`;

const ApplicationsList = styled.div`
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.th`
  padding: 15px;
  text-align: left;
  background-color: #f8f9fa;
  font-weight: 600;
  color: #555;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: #f9f9f9;
  }
`;

const TableCell = styled.td`
  padding: 15px;
  color: #333;
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  color: #555;
  cursor: pointer;
  margin-right: 10px;
  padding: 5px;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    color: #00761F;
    transform: scale(1.1);
  }
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #555;
  cursor: pointer;
  margin-right: 10px;
  padding: 5px;
  border-radius: 4px;
  
  &:hover {
    color: #dc3545;
    background-color: rgba(220, 53, 69, 0.1);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const NoResults = styled.div`
  padding: 30px;
  text-align: center;
  color: #666;
`;

const EditFormContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
`;

const FormHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: #00761F;
  cursor: pointer;
  margin-right: 15px;
  padding: 5px;
  border-radius: 4px;
  
  &:hover {
    background-color: rgba(0, 118, 31, 0.1);
  }
`;

const FormTitle = styled.h2`
  font-size: 20px;
  color: #333;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  transition: border-color 0.2s;
  &:focus {
    outline: none;
    border-color: #00761F;
  }
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  p {
    font-size: 18px;
    color: #555;
    margin-bottom: 20px;
  }
`;

const Label = styled.label`
  position: absolute;
  top: -18px;
  left: 0;
  transform: translateY(-50%);
  font-size: 14px;
  color: #6c757d;
  transition: all 0.3s ease;
  pointer-events: none;
  z-index: 1;

  ${Input}:focus + &, ${Input}:not(:placeholder-shown) + & {
    top: 0;
    font-size: 12px;
    color: #00761F;
    background-color: white;
    padding: 0 5px;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 15px;
  
  &:focus {
    outline: none;
    border-color: #00761F;
  }
  
  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
`;

const CancelButton = styled.button`
  background-color: #f0f0f0;
  color: #555;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #e0e0e0;
  }
`;

const SaveButton = styled.button`
  background-color: #00761F;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #00661a;
  }
`;

const UsersContainer = styled.div`
  flex: 1;
  padding: 30px;
  overflow-y: auto;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;

const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #00761F;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #00661a;
  }
`;

const UsersList = styled.div`
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
`;

const UserRoleBadge = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => props.admin ? 'rgba(0, 118, 31, 0.1)' : 'rgba(108, 117, 125, 0.1)'};
  color: ${props => props.admin ? '#00761F' : '#6c757d'};
`;

const ChangePasswordContainer = styled.div`
  flex: 1;
  padding: 30px;
  max-width: 600px;
  margin: 0 auto;
`;

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #e9f5f0, #d4edda); /* Fundo suave e acadêmico */
`;


const LoginForm = styled.form`
  background-color: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200px;
    height: 200px;
    background-color: rgba(0, 118, 31, 0.1); /* Verde suave */
    transform: rotate(45deg);
    z-index: 0;
  }
`;


const Logo = styled.img`
  width: 120px;
  margin-bottom: 20px;
  z-index: 1; /* Garante que o logo esteja acima do pseudo-elemento */
`;

const LoginTitle = styled.h1`
  font-size: 24px;
  color: #00761F; /* Verde acadêmico */
  margin-bottom: 25px;
  font-weight: 600;
  z-index: 1;
`;

const ErrorMessage = styled.div`
  color: #dc3545;
  background-color: rgba(220, 53, 69, 0.1);
  padding: 12px 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
  z-index: 1;
`;

const LoginButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #00761F, #005c14); /* Gradiente verde */
  color: white;
  border: none;
  padding: 14px;
  border-radius: 8px;
  font-size: 16px;
  font-weight:
`;

const Notification = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 15px 20px;
  border-radius: 6px;
  background-color: ${props => props.type === 'error' ? '#dc3545' : '#00761F'};
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  animation: ${motion.fadeIn} 0.3s ease;
`;

const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    borderRadius: '10px',
    padding: '30px',
    maxWidth: '500px',
    width: '90%',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    backgroundColor: 'white'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000
  }
};

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const ModalTitle = styled.h2`
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
`;

const ModalText = styled.p`
  color: #555;
  margin-bottom: 30px;
  text-align: center;
`;

const ModalButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
`;

const ModalButtonsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const ModalButtonCancel = styled.button`
  background-color: #f0f0f0;
  color: #555;
  border: none;
  padding: 12px 20px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;
  
  &:hover {
    background-color: #e0e0e0;
  }
`;

const ModalButtonConfirm = styled.button`
  background-color: #00761F;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #00661a;
  }
`;

const WelcomeModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const WelcomeTitle = styled.h2`
  font-size: 24px;
  color: #00761F;
  margin: 20px 0 10px;
`;

const WelcomeText = styled.p`
  color: #555;
  margin-bottom: 30px;
`;

const WelcomeButton = styled.button`
  background-color: #00761F;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #00661a;
  }
`;

const PrintOptionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: #f0f0f0;
  color: #333;
  border: none;
  padding: 15px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  
  &:hover {
    background-color: #e0e0e0;
  }
`;
const ErrorState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  p {
    font-size: 18px;
    color: #dc3545;
    margin-bottom: 20px;
  }
`;
const GraphContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;
  max-height: 300px;
  overflow: hidden;

  canvas {
    max-height: 250px !important;
  }
`;
export default AdminPanel;